import app from '../app';

app.directive('iframeOnload', [
  function () {
    return {
      scope: {
        callBack: '&iframeOnload',
      },
      link(scope, element) {
        element.on('load', function () {
          return scope.callBack();
        });
      },
    };
  },
]);
